module.exports = __webpack_public_path__ + "static/media/orange.8f2cc7c8.jpg";